import React from 'react';

import { EsThemeAccount } from '../../common/EsThemeContext';
import { useAuth } from '../parent/EsAuth';

/**
 * Who is signed in, told to EsThemeProvider -- which sits above AuthProvider
 * and so cannot ask. Rendered once, inside AuthProvider, in index.js.
 */
export default function EsThemeWho() {
    const auth = useAuth();
    return <EsThemeAccount auth={ auth } />;
}
